module.exports = __webpack_public_path__ + "static/2-c84a86e11f3d7c232d51e6928734be13.jpg";